import script from "./InsuranceListComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./InsuranceListComponent.vue?vue&type=script&setup=true&lang=ts"

import "./InsuranceListComponent.vue?vue&type=style&index=0&id=19a81d14&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19a81d14"]])

export default __exports__